(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("externalUrlLearnerAccess", {
        templateUrl: "app/account/learnerAccess/learningItemType/externalUrlLearnerAccess.component.html",
        require: {
            parentCtrl: "^^learningItemLearnerAccessModal"
        },
        controller: ["assignmentLearnerAccessUrlResource", "$window", "messageService", "$stateParams", ExternalUrlLearnerAccessCtrl],
        controllerAs: "vm"
    });
    function ExternalUrlLearnerAccessCtrl(assignmentLearnerAccessUrlResource, $window, messageService, $stateParams) {
        var vm = this;
        vm.learningItemUrl = {};
        this.$onInit = function () {
            vm.assignment = vm.parentCtrl.assignment;
            vm.isMobile = jQuery.browser.mobile;
            vm.parentCtrl.isMobile = vm.isMobile;
            load();
        };
        function load() {
            assignmentLearnerAccessUrlResource.get({ id: vm.assignment.id }, function (data) {
                vm.learningItemUrl = data;
                switch (vm.assignment.assignmentStatus) {
                    case 0:
                        break;
                    case 1:
                    case 2:
                    case 3:
                        setupLearningItem();
                        if (vm.assignment.expiring)
                            setupRequalifyButton();
                        break;
                    case 4:
                        setupRequalifyButton();
                        break;
                }
                vm.parentCtrl.contentLoaded = true;
            });
        }
        var setupLearningItem = function () {
            if (!vm.assignment.pathExpiringOrExpired) {
                if (vm.learningItemUrl.isEmbedded) {
                    if (vm.assignment.assignmentStatus === 1) {
                        completeAssignment();
                    }
                }
                else {
                    vm.parentCtrl.buttons = "goToUrl.tpl";
                    vm.parentCtrl.goToUrl = vm.goToUrl;
                    vm.parentCtrl.url = vm.learningItemUrl.url;
                }
            }
        };
        var setupRequalifyButton = function () {
            vm.parentCtrl.buttons = "requalify.tpl";
            vm.parentCtrl.requalify = vm.requalify;
            vm.parentCtrl.url = vm.learningItemUrl.url;
        };
        vm.goToUrl = function () {
            if (vm.assignment.assignmentStatus === 1) {
                if (vm.isMobile)
                    $window.open(vm.learningItemUrl.url);
                vm.assignment.$complete({ number: $stateParams.number, version: $stateParams.version, code: $stateParams.code }, function () {
                    vm.parentCtrl.dismiss();
                }, function (error) {
                    messageService.error(error);
                });
            }
            else if (vm.assignment.assignmentStatus === 3) {
                if (vm.isMobile)
                    $window.open(vm.learningItemUrl.url);
                vm.parentCtrl.dismiss();
            }
        };
        vm.requalify = function (btn) {
            if (btn.target.disabled)
                return;
            btn.target.disabled = true;
            vm.assignment.$requalify({ number: $stateParams.number, version: $stateParams.version, code: $stateParams.code }, function () {
                if (vm.learningItemUrl.isEmbedded) {
                    vm.assignment.assignmentStatus = 1;
                    vm.assignment.expired = false;
                    vm.assignment.expiring = false;
                    vm.assignment.pathExpiringOrExpired = false;
                    vm.parentCtrl.assignmentStatusClass = "assigned";
                    vm.parentCtrl.buttons = "";
                }
                else {
                    if (vm.isMobile)
                        $window.open(vm.learningItemUrl.url);
                    vm.parentCtrl.dismiss();
                }
            }, function (error) {
                messageService.error(error);
            });
        };
        var completeAssignment = function () {
            vm.assignment.$complete({ number: $stateParams.number, version: $stateParams.version, code: $stateParams.code }, function () {
            }, function (error) {
                messageService.error(error);
            });
        };
    }
}());
